import { render, staticRenderFns } from "./dataSynchronization.vue?vue&type=template&id=03cbe9d0&scoped=true&"
import script from "./dataSynchronization.vue?vue&type=script&lang=js&"
export * from "./dataSynchronization.vue?vue&type=script&lang=js&"
import style0 from "./dataSynchronization.vue?vue&type=style&index=0&id=03cbe9d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cbe9d0",
  null
  
)

component.options.__file = "dataSynchronization.vue"
export default component.exports